export default "__VITE_ASSET__DqxJ9dNW__"